import CalendarModuleHamburgerButton from '../components/CalendarModuleHamburgerButton';
import { toggleCalendarLeftPaneExpansion } from 'owa-calendar-layout';
import { DisplayOption, FilterableMenuItem, FilterableMenuItemArgs } from 'owa-filterable-menu';
import * as React from 'react';

/**
 * Autofocus should be disabled on initial page load to respect normal tab flow,
 * but then become enabled after the first time the button is clicked as a workaround
 * to "preserve" focus on the button post-click (even though the component actually
 * unmounts and remounts in a different DOM position to accomodate the left nav changes).
 *
 * This workaround can be removed if/when the DOM can be restructured/simplified to ensure that
 * the initial component instance can be preserved rather than unmounted and remounted elsewhere.
 */
let shouldAutoFocusHamburgerButton: boolean = false;

export function getHamburgerItem() {
    return new FilterableMenuItem({
        [FilterableMenuItemArgs.name]: 'hamburgerMenu',
        [FilterableMenuItemArgs.displayOption]: DisplayOption.Left,
        [FilterableMenuItemArgs.onRender]: () => (
            <CalendarModuleHamburgerButton
                autoFocus={shouldAutoFocusHamburgerButton}
                isPaneExpanded={false}
                toggleHamburgerButton={onClick}
            />
        ),
    });
}

function onClick() {
    shouldAutoFocusHamburgerButton = true;
    toggleCalendarLeftPaneExpansion();
}
